module.exports = require('./en');



/*****************
 ** WEBPACK FOOTER
 ** ./~/counterpart/~/date-names/index.js
 ** module id = 12
 ** module chunks = 0
 **/